<script setup>
import { RouterView } from 'vue-router'
import TopBar from '@/components/TopBar.vue'
</script>

<template>
  <div class="app-layout">
    <TopBar />
    <div class="app-content">
      <RouterView />
    </div>
  </div>
</template>

<style scoped>
.app-layout {
  min-height: 100vh;
  padding-top: var(--top-bar-height, 64px);
  width: 100%;
}

.app-content {
  min-height: calc(100vh - var(--top-bar-height, 64px));
  max-width: 1000px;
  margin: 0 auto; /* Centers the content */
  width: 100%;
}

header {
  line-height: 1.5;
  max-height: 100vh;
}

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }
}
</style>
